import * as React from "react";
import { connect } from "react-redux";
import Iframe from 'react-iframe';
import { withRouter } from 'react-router';
import { Nav, NavItem } from 'reactstrap';
import { Link } from "react-router-dom";
import Cookies from "cookies-js";
import { getDomain } from "../../helpers/Tools";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import MyChartContainer from "./MyChartContainer";

class PayAsGuest extends React.Component {
    constructor(props) {
        super(props);
        this.serverData = this.props.serverData;
        this.state = {
            localization: 'english',
            localizationLabel: 'Ver en Español'
        };
        this.onLocalizationChangeClick = this.onLocalizationChangeClick.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.PayAsGuest.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    doOpenChat() {
        window.open('https://BSWEgain.bswhealth.org/system/templates/chat/bsw-cbs/chat.html?subActivity=Chat&entryPointId=1005&templateName=bsw-cbs&languageCode=en&countryCode=US&ver=v11', 'newwindow', 'width=300, height=250'); return false;
    }
    onLocalizationChangeClick(e) {
        var myDomain = getDomain();
        var localization = '';
        if (Cookies.get('BSWLOCAL'))
            localization = Cookies.get('BSWLOCAL');
        if (localization && localization.length > 0) {
            if (localization === 'espanol') {
                Cookies.set('BSWLOCAL', 'english', { expires: Infinity, path: '/', domain: myDomain });
                //localizationlabel = "Ver en Español";
                this.setState({ localizationlabel: "Ver en Español" });
            }
            else {
                Cookies.set('BSWLOCAL', 'espanol', { expires: Infinity, path: '/', domain: myDomain });
                //localizationlabel = "View in English";
                this.setState({ localizationlabel: "View In English" });
            }

        }
        else {
            Cookies.set('BSWLOCAL', 'english', { expires: Infinity, path: '/', domain: myDomain });
            //localizationlabel = "View in English";
            this.setState({ localizationlabel: "Ver en Español" });
        }
        Cookies.set('BSWLOCAL', '', { expires: Infinity, path: '/', domain: myDomain });
    }
    render() {
        //debugger;
        var mode = '/billing/guestpay/payasguest';
        var preurl = this.props.serverData.myChartDataTileUrl.replace('/inside.asp?mode=', '');
        var url = `${preurl}${mode}`;
        const iframeResizerOptions = { checkOrigin: false, minHeight: 400, scrolling: true, heightCalculationMethod: 'bodyScroll' };
        const iframeResizerStyle = { width: '100%' };
        var localization = '';
        if (typeof window !== "undefined") {
            if (Cookies.get('BSWLOCAL'))
                localization = Cookies.get('BSWLOCAL');
        }
        if (localization && localization.length > 0)
            url += "?lang=" + localization;

        const heading = null; //{/*<div className="language-link-container"><div className="link-style language-link" onClick={this.onLocalizationChangeClick} >{localization && localization === "english" ? 'Ver en Español' : 'View in English'}</div></div>*/ };
        const footer = (
            <div className="chat">
                <a href="#" onClick={() => this.doOpenChat()}><span className="fa fa-comment fa-lg" aria-hidden="true" /> Chat With An Adviser</a>
            </div>
        );

        return <MyChartContainer
            id={"mychartpayasguest"}
            title="Pay as Guest"
            iframeResizerOptions={iframeResizerOptions}
            src={url}
            style={iframeResizerStyle}
            ignoreChanges
            heading={heading}
            footer={footer}
            myChartNotRequired
            showLanguageLink={false}
        />;
    }
}

const mapStateToProps = (state) => {
    return {
        serverData: state.session.serverData
    };
};

const Tile = connect(
    mapStateToProps
)(PayAsGuest);

export default withRouter(Tile);